import ErrorScreen from "./error-screen";

export default function NotEnabled() {
  return <ErrorScreen title={"Subscriptions Not Enabled"} message={"We're sorry but subscriptions are not enabled for this site."}/>
}